import getProperty from 'lodash-es/get';
import * as React from 'react';
import DataTableBodyCell from './DataTableBodyCell';
import type {ColumnPropType, RowPropType} from './propTypes';
import {columnPropType, rowPropType} from './propTypes';

export type Props = {
    column: ColumnPropType,
    row: RowPropType
}

export default class DataTableBodyValueCell extends React.PureComponent<Props> {

    static propTypes = {
        column: columnPropType.isRequired,
        row: rowPropType.isRequired,
    };

    props: Props;

    render(): React.ReactNode {
        const {column, row, ...otherProps} = this.props;
        const {name, format, component} = column;

        let value = getProperty(row, name);
        if (format) {
            value = format(value, row);
        }
        if (component) {
            value = React.createElement(component, {value, row});
        }

        return (
            <DataTableBodyCell column={column} row={row} {...otherProps}>
                {value}
            </DataTableBodyCell>
        );
    }

}
